import { required, requiredIf } from 'vuelidate/lib/validators'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'
import Fileupload from '@/components/common/fileupload/Fileupload.vue'

const defaultEl = {
  id: null,
  contractNumber: '',
  material_group: null,
  penalty: 0.005,
  isCanceled: 0,
  advanceBill: 1,
  dateFrom: null,
  from_date_period_id: null,
  to_date_period_id: null,
  materialRegistryNumber: null,
  materialRegistryDate: null,
  files: [],
  poNumber: '',
  dueInDays: 15
};

export default {
  name: 'ClientContractEdit',
  data () {
    return {
      editEl: defaultEl,
      loading: false,
      clientApiId: null
    }
  },
  components: {
    DatePeriodPicker,
    Fileupload
  },
  validations: {
    editEl: {
      contractNumber: { required },
      material_group: { required },
      dateFrom: { required },
      from_date_period_id: { required },
      files: {
        $each: {
          file: {
            required: requiredIf(function (el) {
              return (el && !el.filename);
            })
          }
        }
      }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.contract.edit');
      }
      return this.$t('menu.contract.new');
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale);
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    isAuthorizationContract () {
      return this.editEl.material_group === 'AUTH';
    },
    yearOptions () {
      const perConfig = this.$store.state.config ? this.$store.state.config.datePeriodConfig : null;
      const options = [];
      if (perConfig) {
        for (let year = perConfig.endYear; year >= perConfig.startYear; year--) {
          options.push({ value: year, text: year });
        }
      }
      return options;
    },
    yearOptionsWithEmpty () {
      return [{ value: null, text: '' }, ...this.yearOptions];
    },
    authFromYear: {
      get () {
        return this.getYearFromPeriod(this.editEl.from_date_period_id);
      },
      set (year) {
        this.editEl.from_date_period_id = year ? year + '010' : null;
      }
    },
    authToYear: {
      get () {
        return this.getYearFromPeriod(this.editEl.to_date_period_id);
      },
      set (year) {
        this.editEl.to_date_period_id = year ? year + '040' : null;
      }
    },
    yearFromLabel () {
      return this.$t('contract.yearFrom');
    },
    yearToLabel () {
      return this.$t('contract.yearTo');
    },
    canEdit () {
      return (!this.loading && this.ApiRequest.userHasPermission('edit-clients', this.clientApiId, []));
    },
    canEditAdmin () {
      return (!this.loading && this.ApiRequest.userHasPermission('edit-clients'));
    },
    isAdmin () {
      return this.ApiRequest.userHasPermission('edit-clients');
    }
  },
  methods: {
    getYearFromPeriod (periodId) {
      return periodId ? parseInt((periodId + '').substr(0, 4)) : null;
    },
    show (elData, clientApiId) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.editEl.material_group = this.$store.getters.getParamFromConfig('material_groups', this.editEl.material_group_id, 'code');
      this.editEl.penaltypercent = (this.editEl.penalty ? (parseFloat(this.editEl.penalty) * 100).toFixed(4) : this.editEl.penalty);
      this.clientApiId = clientApiId;
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const formEls = (this.isAdmin ? Object.keys(defaultEl) : ['poNumber', 'id']);
        this.editEl.penalty = (this.editEl.penaltypercent ? (parseFloat(this.editEl.penaltypercent) / 100).toFixed(6) : 0);
        const reqData = this.ApiRequest.createFormData(this.editEl, formEls, 'contract', this);
        const self = this;
        if (reqData) {
          const path = 'client/single/' + this.clientApiId + '/contracts';
          this.ApiRequest.request(path, this.ApiRequest.REQUEST_FILEUPLOAD, reqData, function (response) {
            if (response.error) {
              self.ApiRequest.displayErrorDialog(response, self);
              self.$emit('saved', null);
            } else {
              self.$emit('saved', response.data);
            }
            self.close();
            self.loading = false;
          });
        } else {
          self.ApiRequest.displayErrorDialog({ message: self.$t('general.validator.file-required') }, self);
          self.loading = false;
        }
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    downloadfile (key) {
      this.editEl.files[key].loading = true;
      this.$refs.fileupload.forceUpdate(key);
      const self = this;
      this.ApiRequest.request('client/files/download/contract/' + this.editEl.files[key].id, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.editEl.files[key].loading = false;
        self.$refs.fileupload.forceUpdate(key);
      });
    }
  }
}
